import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Award } from 'lucide-react';
const certs = ['Project Management Professional (PMP)', 'PROSCI Certified Change Management Practitioner', 'Certified Scrum Master (CSM)', 'Lean Six Sigma Green Belt', 'Human-Centered Design (HCD)'];
export function Certifications() {
  return <Section id="certifications" background="gray" data-id="element-55">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-56">
        <div data-id="element-57">
          <FadeIn data-id="element-58">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 border-l-4 border-[#1e3a8a] pl-4" data-id="element-59">
              Certifications
            </h2>
          </FadeIn>
          <StaggerContainer className="space-y-4" data-id="element-60">
            {certs.map((cert, index) => <StaggerItem key={index} className="flex items-center bg-white p-4 rounded-lg shadow-sm" data-id="element-61">
                <Award className="w-6 h-6 text-[#1e3a8a] mr-4 flex-shrink-0" data-id="element-62" />
                <span className="text-gray-800 font-medium" data-id="element-63">{cert}</span>
              </StaggerItem>)}
          </StaggerContainer>
        </div>

        <div data-id="element-64">
          <FadeIn delay={0.2} data-id="element-65">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 border-l-4 border-[#1e3a8a] pl-4" data-id="element-66">
              Education
            </h2>
          </FadeIn>
          <div className="space-y-6" data-id="element-67">
            <FadeIn delay={0.3} className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-[#1e3a8a]" data-id="element-68">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-69">
                Johns Hopkins University
              </h3>
              <p className="text-[#1e3a8a] font-medium" data-id="element-70">
                MS, Information Systems
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="bg-white p-6 rounded-lg shadow-sm border-l-4 border-gray-300" data-id="element-71">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-72">
                Ohio Northern University
              </h3>
              <p className="text-gray-600 font-medium" data-id="element-73">
                BS, Business Administration
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
}